<template>
	<div class="exhibit-wrap">
		<el-breadcrumb separator="/" class="path">
			<el-breadcrumb-item :to="{ path: '/' }" class="path-home">
				<i class="n el-icon-s-home"></i>
				首页
			</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/exhibit' }">展会</el-breadcrumb-item>
			<el-breadcrumb-item class="path-help">展会详情</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="news" v-loading="loading" >
			<div class="content">
				<div class="left-column">
					<div class="detail" v-if="detail">
						<h1>{{detail.title}}</h1>
						
						<div class="info">
							<el-image fit="cover" class="image" :src="$img(detail.thumb)" @error="detail.thumb = defaultGoodsImage" />
							<ul>
								<li>
									<span>主办单位:</span>
									<p>{{detail.organizer||'暂无'}}</p>
								</li>
								<li>
									<span>展会时间:</span>
									<p>{{detail.start_time}} - {{detail.end_time}}</p>
								</li>
								<li>
									<span>所在城市:</span>
									<p>{{detail.city||'暂无'}}</p>
								</li>
								<li>
									<span>展出地址:</span>
									<p>{{detail.address||'暂无'}}</p>
								</li>
								<li>
									<span>展馆:</span>
									<p>{{detail.hall||'暂无'}}</p>
								</li>
								<li>
									<span>联系方式:</span>
									<p>{{detail.tel||detail.phone||detail.fax||detail.email||detail.email||detail.email||'暂无'}}</p>
								</li>
							</ul>
						</div>
						<sub-title title="展会详情"></sub-title>
						<div class="account">
							<!-- <span>作者:{{detail.author|| $config.title}}</span> -->
							<span>分类:
								<router-link :to="`/exhibit-list-${detail.cat_id}`" >{{detail.category.name||''}}</router-link>
							</span>
							<span>发布时间:{{detail.create_time}}</span>
						</div>
						<div class="content" v-html="content()"></div>
					</div>
					<div class="other">
						<sub-title title="相关资讯"></sub-title>
						<!-- {{newsList}} -->
						<news-list1 :list="newsList"></news-list1>
					</div>
				</div>
				<div class="right-column">
					<news-sidebar></news-sidebar>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import { helpDetail } from '@/api/cms/help';
import {
	// newsCat,
	newsList,
	// exhibitDetail
} from "@/api/cms/news";
import {
	// newsCat,
	// newsList,
	exhibitDetail
} from "@/api/cms/exhibit";
import sidebar from "./components/sidebar"
import SubTitle from "@/components/SubTitle"
import DescText from "@/components/DescText"
import list1 from "./components/list1"
import newsList1 from "../news/components/list1"
import newsSidebar from "../news/components/sidebar"


export default {
	name: 'exhibit_detail',
	components: {
		sidebar,
		SubTitle,
		list1,
		newsList1,
		newsSidebar
	},
	data: () => {
		return {
			id:null,
			loading: true,
			detail:null,
			newsList:[]
		};
	},
	created() {
		this.id = this.$route.path.replace('/exhibit-detail-', '');
		// console.log(1333333333333,this.id);
		this.getDetail();
		this.getNewsList();
	},
	watch: {
		$route(curr) {
			this.id = curr.params.pathMatch;
			// console.log(22222);
			// this.getDetail();
		}
	},
	methods: {
		getDetail() {
			exhibitDetail({
				id: this.id
			}).then(res => {
				if (res.code == 0) {
					if (res.data) {
						this.loading = false;
						this.detail = res.data;
					} else {
						console.log(333)
						// this.$router.push({ path: '/cms/help' });
					}
				}
			}).catch(err => {
				this.loading = false;
				this.$message.error(err.message);
			});
		},
		getNewsList() {
			newsList({
				// id: this.id
				// page:
			}).then(res => {
				if (res.code == 0 && res.data) {
						// this.loading = false;
					this.newsList = res.data.list;
				} else {
					// console.log(333)
					// this.$router.push({ path: '/cms/help' });
				}
			}).catch(err => {
				// this.loading = false;
				this.$message.error(err.message);
			});
		},
		content(){
			let c = this.detail.content || '';
			c= c.replace(/<img[^>]*>/gi,function(match,capture){
				match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
				match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
				return match;
			});
			// console.log(111,c)
			// newContent = newContent.replace(/\<img[^>]*>/gi, '2222222222222');
//         	newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
//         		match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
//         		return match;
//         	});
			
        	c = c.replace(/<br[^>]*\/>/gi, '<br>');
//         	newContent = newContent.replace(/\<img[^>]*>/gi, '');
			// console.log(1211,c)
        	c = c.replace(/<p[^>]*>/gi,'<p>')
			// console.log(133311,c)
			// newContent = newContent.replace(/(<([^>]+)>)/ig, '');
			// c = c.replace(/\s+/g,"");
			// console.log(4111,c)
			return c;
			// ()detail.content
		}
	}
};
</script>
<style lang="scss" scoped>
.exhibit-wrap {
	background: #ffffff;
	.path {
		padding: 15px 0;
	}
}
	
.news {
	padding-bottom: 20px;
	.content{
		display: flex;
		flex-flow: wrap;
		width: 1210px;
		margin-bottom: 20px;
		.left-column{
			width: 900px;
			// flex: 1;
			display: block;
			.detail{
				display: block;
				overflow: hidden;
				h1{
					text-align: center;
					// line-height: 60px;
				}
				.account{
					// margin:  0 0 0 ;
					text-align: right;
					span{
						margin:0  10px;
					}
				}
				.info{
					background-color: $base-color;//#f8f8f8;
					display: flex;
					flex-wrap: wrap;
					padding: 25px;
					// border: 2px solid $base-color;
					color:#fff;
					border-top-left-radius: 25px;
					border-bottom-right-radius: 25px;
					margin:  15px 0;
					.image{
						width: 220px;
						height: 130px;
						margin-top: 25px;
					}
					ul{
						flex: 1;
						li{
							padding: 0 15px;
							display: flex;
							flex-wrap: wrap;
							span{
								width: 150px;
								text-align: justify;
							}
							p{
								flex: 1;
							}
						}
					}
				}
				.content{
					margin: 15px 0 0 0 ;
					display: block;
					overflow: hidden;
					width: 100%;
					
				}
				
			}
			
		}
		.right-column{
			// width: 260px;
			flex: 1;
			padding-left: 20px;
			overflow: hidden;
		}
	}
}
</style>
